var _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "url(#paint0_linear_317_1308)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0325 36.5368L34.8049 39.5541L32.0687 39.4291H31.8188L31.7161 45.2987L31.8813 49.6551H27.7346L27.9399 45.7138L27.8373 39.4291H27.5695L24.811 39.5541L24.561 39.264L24.7887 36.2377H34.8049L35.0325 36.5278V36.5368ZM47.0216 49.6641H42.8125L42.4376 47.4323V47.3698L40.4022 47.3296L38.6926 47.4234L38.34 49.6551H34.2782L38.34 36.2377H43.3526L47.0216 49.6551V49.6641ZM41.8171 44.3569L40.9244 39.9603H40.6745L39.5139 44.3569H40.6745H41.835H41.8171ZM56.3371 42.5715L60.3811 49.6641H55.3997L54.6945 48.0349L53.4938 45.8477L51.9583 48.2357L51.2933 49.6641H47.0841L51.0656 43.2142L46.9591 36.2466H51.936L52.6636 37.9249L53.8687 40.0406L55.2078 37.6973L55.8282 36.2466H60.1623L56.3148 42.5715H56.3371Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9973 17.0846C38.3065 14.4773 45.36 14.31 51.7858 16.6152C58.2116 18.9204 63.5503 23.5332 66.7634 29.5565C69.9766 35.5798 70.8345 42.5829 69.1703 49.2037C67.5061 55.8245 63.4388 61.5897 57.7595 65.3778C52.0802 69.1659 45.1949 70.7062 38.4428 69.699C31.6908 68.6918 25.5547 65.2092 21.2281 59.9286C16.9016 54.6479 14.6938 47.9468 15.0342 41.1285C15.3747 34.3102 18.2391 27.8624 23.0702 23.039C25.6236 20.4843 28.6577 18.4606 31.9973 17.0846ZM28.0738 25.5921L59.2964 56.837C62.9575 52.6057 64.8812 47.1453 64.6805 41.5536C64.4798 35.9618 62.1697 30.6534 58.2146 26.6955C54.2595 22.7376 48.9527 20.4236 43.3611 20.219C37.7695 20.0143 32.3077 21.934 28.0738 25.5921ZM56.8459 59.2652L25.6233 28.0426C21.9652 32.2765 20.0455 37.7383 20.2502 43.3299C20.4548 48.9215 22.7687 54.2283 26.7267 58.1834C30.6846 62.1385 35.993 64.4486 41.5848 64.6493C47.1765 64.85 52.6369 62.9264 56.8682 59.2652H56.8459Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_317_1308",
    x1: 128.912,
    y1: 76.2137,
    x2: 64.2309,
    y2: -57.8121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B947F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#106554"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxIcon);
export default __webpack_public_path__ + "static/media/TaxIcon.833284ba248ade18f018473a97ea5775.svg";
export { ForwardRef as ReactComponent };